<template>
  <vue-plyr ref="plyr" :options="options">
    <div class="plyr__video-embed">
        <!-- :src="`${src}?autoplay=1`" -->
      <iframe :src="src"
        allowfullscreen
        allowtransparency
        allow="autoplay" />
    </div>
  </vue-plyr>
</template>

<script>
export default {
  name: 'VideoPlayer',
  props: {
    isInViewport: {
      type: Boolean,
      default() {
        return false
      },
    },
    options: {
      type: Object,
      default() {
        return {
          loop: {
            active: true
          }
        }
      },
    },
    src: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      player: null
    }
  },
  mounted() {
    this.player = this.$refs.plyr.player
  },
  watch: {
    isInViewport(newVal) {
      if(newVal && this.player) {
        this.player.play()
      } else {
        this.player.pause()
      }
    }
  }
};
</script>